import { COMPANY } from '~/constants/Masterdata';

import { camelcaseKeysFromApi } from '@vestigas/data';
import { type DeliveryNoteListItem } from '~/data/deliveryNote/types';

import { ConcreteObject } from '~/models/articles';

export const DeliveryNoteParserObject = {
  parseAssetMain(assetMain: Partial<DeliveryNoteListItem> = {}) {
    assetMain = camelcaseKeysFromApi(assetMain);

    if (
      [
        COMPANY.UNION_BETON,
        COMPANY.GANSER_BETON,
        COMPANY.FERTIGBETON_STIEB,
      ].includes(assetMain?.assetState?.body?.header?.issuer?.id ?? '') && // issuer
      [
        COMPANY.UNION_BETON,
        COMPANY.GANSER_BETON,
        COMPANY.FERTIGBETON_STIEB,
      ].includes(
        assetMain?.assetState?.body?.transaction?.delivery?.shipFrom
          ?.legalOrganization?.id ?? '',
      ) // supplier
    ) {
      this.parseRohrdorfer(assetMain);
    }
  },

  parseRohrdorfer(assetMain: Partial<DeliveryNoteListItem> = {}) {
    assetMain = camelcaseKeysFromApi(assetMain);

    // concrete always has an 8 digit article number
    if (
      assetMain?.assetState?.body?.transaction?.logisticsPackage?.[0]
        ?.lineItem?.[0]?.product?.sellerAssignedId?.length !== 8
    ) {
      return;
    }

    // replace EA with MTQ for concrete
    if (
      assetMain?.assetState?.body?.transaction?.logisticsPackage?.[0]
        ?.lineItem?.[0]?.delivery?.productUnit?.quantityType === 'EA'
    ) {
      assetMain.assetState.body.transaction.logisticsPackage[0].lineItem[0].delivery.productUnit.quantityType =
        'MTQ';
    }

    if (
      !assetMain.assetState.body.transaction.logisticsPackage[0].lineItem[0]
        .product.name
    ) {
      return;
    }

    let [strengthClass, exposureClass, consistency, largestGrain] =
      assetMain.assetState.body.transaction.logisticsPackage[0].lineItem[0].product.name.split(
        ' ',
      );

    // only map concrete (e.g. Sandbeton is filtered out here)
    if (!ConcreteObject.STRENGTH_CLASSES.includes(strengthClass)) {
      return;
    }

    // handle the case if the corrosion class is mapped to the largest grain
    if (!ConcreteObject.LARGEST_GRAINS.includes(largestGrain)) {
      largestGrain = '';
    }

    assetMain.assetState.body.transaction.logisticsPackage[0].lineItem[0].product =
      {
        concrete: {
          consistency,
          exposureClass,
          largestGrain,
          strengthClass,
        },
        ...assetMain.assetState.body.transaction.logisticsPackage[0].lineItem[0]
          .product,
      };
  },
};
